import Carousel from 'react-bootstrap/Carousel';
import Hero from '../components/Hero';

function HomeHero() {

  return (
    <>
    <Carousel className='home-hero-carousel' fade indicators={false}>
      <Carousel.Item>
        <Hero
          bannerKey="home-1"
          text1="Quand mon traitement pour le cancer du sang s'est arrêté,"
          text2="je me suis demandé ce qu'il fallait faire maintenant."
          image="visuel-home-1.png"
          color="salmon"
        />
      </Carousel.Item>
      <Carousel.Item>
        <Hero
          bannerKey="home-2"
          text1="La période d'après-traitement,"
          text2="c'est aussi un accompagnement et un suivi plus espacé"
          image="visuel-home-2.png"
          color="turquoise"
        />
      </Carousel.Item>
    </Carousel>
    </> 
  )
}

export default HomeHero